export const ADMINISTRATION_RULES: string = 'engines';
export const ADMINISTRATION_CHANNELING: string = 'channeling';
export const ADMINISTRATION_RULES_SETTINGS_ENGINES: string = 'settings';
export const ADMINISTRATION_RULES_SETTINGS_RULE: string = 'rule';

